import React from "react"
import { Common } from "lib/types"
import { ReactComponent as WorkflowIcon } from "images/icons/circle-nodes.svg"
import { PermissionGroups } from "../constants"

import { Workflows } from "views/Workflows/Workflows"
import { ShowWorkflows } from "views/Workflows/ShowWorkflows"
import { CreateWorkflow } from "views/Workflows/CreateWorkflow"
import { EditWorkflow } from "views/Workflows/EditWorkflow"

export const workflowRoutes: Common.Views = [
  {
    element: <Workflows />,
    path: "/settings/workflows",
    title: "Workflows",
    icon: WorkflowIcon,
    sortOrder: 5,
    requiredGroups: PermissionGroups.workflows.read,
    configKey: "workflowsEnabled",
    children: [
      {
        element: <ShowWorkflows />,
        path: "/settings/workflows/",
        title: "Show workflows",
        parentPath: "/settings/workflows",
        section: "Workflows"
      },
      {
        element: <CreateWorkflow />,
        path: "/settings/workflows/create",
        title: "Create workflow",
        parentPath: "/settings/workflows",
        requiredGroups: PermissionGroups.workflows.write
      },
      {
        element: <EditWorkflow />,
        path: "/settings/workflows/:id",
        title: "Edit workflow",
        parentPath: "/settings/workflows"
      }
    ]
  }
]
